
export let config = {
  GET_CONF_API: 'https://api-prod.getfeasy.com/public/hey-link/get-conf',

  LS_KEY_OAG_TOKEN:'hey_oag_tech_token',
  LS_KEY_TECH_TOKEN: 'hey_tech_token',
  LS_KEY_TOKEN: 'hey_token',
  LS_KEY_PUBLIC_ID: 'hey_public_id',
  LS_KEY_PUBLIC_EMAIL: 'hey_public_email',
  LS_KEY_REFRESH_TOKEN: 'hey_refresh_token',
  LS_KEY_TOKEN_EXPIRES: 'hey_token_expires_at',
  LS_KEY_CONFIG_CACHE: 'hey_config_cache',
};